import { useState } from 'react';
import { Input, Button } from '@selfinspectionorg/ui-kit';
import type { InputProps } from '@selfinspectionorg/ui-kit';
import classNames from 'classnames';
import EyeIcon from './eye.svg?react';
import styles from './PasswordInput.module.scss';

export type PasswordInputProps = Omit<InputProps, 'type'>;

export const PasswordInput = ({ addonAfter, ...props }: PasswordInputProps) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const eyeButton = (
    <Button.Ghost
      className={classNames(styles.showPasswordButton, {
        [styles.showPasswordButton_enabled]: showPassword,
      })}
      onClick={togglePasswordVisibility}
    >
      <EyeIcon />
    </Button.Ghost>
  );

  return <Input {...props} type={showPassword ? 'text' : 'password'} addonAfter={addonAfter ?? eyeButton} />;
};
